export const emptyValue = '-';
export const disponibilidadeFrotaPatioStorageKey = 'disponibilidade-frota-patio';
export const posicoesFrotaPatioStorageKey = 'disponibilidade-frota-patio-posicoes';
export const plotagemLabelById = {
  0: 'Sem Informação',
  4: 'HAVAN',
  5: 'TRANSBEN',
  6: 'PATRIOTA'
};

export const statusPatioLabels = {
  1: 'Disponiveis',
  2: 'Indisponivel',
  3: 'Em Rota',
  4: 'Problemas Identificados',
  5: 'Manutencao'
};

export const statusPatioVariants = {
  1: 'success',
  2: 'danger',
  3: 'danger',
  4: 'warning',
  5: 'warning'
};

export const positionHydrationConcurrency = 10;
export const positionRefreshIntervalMs = 30 * 60 * 1000;
export const positionRequestConfig = {
  skipNotification: true,
  headers: {
    'x-skip-notification': true
  }
};

export const refreshIntervalSeconds = 5 * 60;
export const refreshIntervalMs = refreshIntervalSeconds * 1000;
export const emptyFilterOverrides = {};

export const mapFallbackCenter = [-14.235, -51.9253];
export const mapFallbackZoom = 4;
export const singleVehicleMapZoom = 12;
export const mapContainerHeight = 'clamp(540px, 68vh, 760px)';

export const allRegionsOption = {
  value: '',
  label: 'Todas as regioes'
};

export const regionLabelByState = {
  AC: 'Norte',
  AL: 'Nordeste',
  AM: 'Norte',
  AP: 'Norte',
  BA: 'Nordeste',
  CE: 'Nordeste',
  DF: 'Centro-Oeste',
  ES: 'Sudeste',
  GO: 'Centro-Oeste',
  MA: 'Nordeste',
  MG: 'Sudeste',
  MS: 'Centro-Oeste',
  MT: 'Centro-Oeste',
  PA: 'Norte',
  PB: 'Nordeste',
  PE: 'Nordeste',
  PI: 'Nordeste',
  PR: 'Sul',
  RJ: 'Sudeste',
  RN: 'Nordeste',
  RO: 'Norte',
  RR: 'Norte',
  RS: 'Sul',
  SC: 'Sul',
  SE: 'Nordeste',
  SP: 'Sudeste',
  TO: 'Norte',
  ACRE: 'Norte',
  ALAGOAS: 'Nordeste',
  AMAPA: 'Norte',
  AMAZONAS: 'Norte',
  BAHIA: 'Nordeste',
  CEARA: 'Nordeste',
  'DISTRITO FEDERAL': 'Centro-Oeste',
  'ESPIRITO SANTO': 'Sudeste',
  GOIAS: 'Centro-Oeste',
  MARANHAO: 'Nordeste',
  'MATO GROSSO': 'Centro-Oeste',
  'MATO GROSSO DO SUL': 'Centro-Oeste',
  'MINAS GERAIS': 'Sudeste',
  PARA: 'Norte',
  PARAIBA: 'Nordeste',
  PARANA: 'Sul',
  PERNAMBUCO: 'Nordeste',
  PIAUI: 'Nordeste',
  'RIO DE JANEIRO': 'Sudeste',
  'RIO GRANDE DO NORTE': 'Nordeste',
  'RIO GRANDE DO SUL': 'Sul',
  RONDONIA: 'Norte',
  RORAIMA: 'Norte',
  'SANTA CATARINA': 'Sul',
  'SAO PAULO': 'Sudeste',
  SERGIPE: 'Nordeste',
  TOCANTINS: 'Norte'
};

export const orderedRegionLabels = ['Norte', 'Nordeste', 'Centro-Oeste', 'Sudeste', 'Sul'];
